export default __webpack_public_path__ + "static/media/supercity.a133a31d.png";